<!--
 * @Description: 开票信息。上传发票方可以修改结算月度
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseForm
    ref="formRef"
    label-position="top"
    scrollToError
    :model="formData"
    :rules="formRules"
  >
    <div class="form-dialog__title">
      <h1>开票信息</h1>
    </div>
    <div class="form-dialog__content">
      <!-- 企业名称为购买方名称，可能是服务商或者供应商，没有根据类型处理~~ -->
      <BaseFormItem label="企业名称" prop="aspName">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="
            formData.aspName || formData.supplierName || formData.theBuyerName
          "
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="纳税识别号" prop="invoiceIdentifierNo">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="formData.invoiceIdentifierNo"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="联系电话" prop="invoicePhone">
        <BaseInput
          class="form-dialog__w280"
          type="tel"
          placeholder="请输入"
          disabled
          :modelValue="formData.invoicePhone"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="开户银行" prop="invoiceOpenBank">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="formData.invoiceOpenBank"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="银行账号" prop="invoiceBankNo">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="formData.invoiceBankNo"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="企业地址" prop="invoiceEnterpriseAddress">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="formData.invoiceEnterpriseAddress"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="发票类型" prop="invoiceTypeName">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="formData.invoiceTypeName"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="发票类目" prop="itemName">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="formData.itemName"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="订单类型" prop="orderMixtureType">
        <BaseSelect
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="formData.orderMixtureType"
          :options="ORDER_TYPE"
        ></BaseSelect>
      </BaseFormItem>
      <BaseFormItem label="价税合计" prop="invoiceAmount">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="formatter.fen2yuan(formData.invoiceAmount)"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="结算月度" prop="taskAt" v-if="!isType7">
        <BaseDatePicker
          style="width: 100%"
          type="month"
          validate-event
          :disabled="disabled"
          v-model="formData.taskAt"
        ></BaseDatePicker>
      </BaseFormItem>
    </div>
  </BaseForm>
</template>

<script lang="tsx" setup>
import { ref, computed } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseSelect,
  BaseDatePicker
} from 'xrk-components';
import { InvoiceApplyDTO } from '@V/invoice/src/data-source/types';
// import { useVModel } from '@vueuse/core';
import { ORDER_TYPE } from '@constants/order';
import { formatter } from '@/utils';
import { DetailType } from '@V/invoice/src/types';
// import appStore from '@/store';
// import { storeToRefs } from 'pinia';
import { StateType } from '@cTypes/order';

const props = withDefaults(
  defineProps<{
    detailType: DetailType;
    invoiceBusinessType?: StateType;
  }>(),
  {}
);
// const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

const disabled = !(
  [2].includes(props.detailType) //  && userInfo.value.functionCode === 3
);

const formRef = ref(null);
const formData = defineModel<InvoiceApplyDTO>();
const formRules = {
  // taskAt: [{ required: true, message: '请选择', trigger: 'change' }]
};
// 个体相关类型
const isType7 = computed(() => [7, 9, 10].includes(props.invoiceBusinessType));

defineExpose({
  validate: (...args: any) => formRef.value?.validate(...args)
});
</script>
